export enum SourceKey {
	// EAP
	FASTSHIFT_PORTAL_DASHBOARD_SCREEN = 'fastshiftPortalDashboardScreen',

	// M2
	FASTSHIFT_PORTAL_SELECTION_SCREEN = 'fastshiftPortalSelectionScreen',
	FASTSHIFT_PORTAL_FOR_YOU_SCREEN = 'fastshiftPortalForYouScreen',
	FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN = 'fastshiftPortalMigrationPlanningScreen',
	FASTSHIFT_PORTAL_CUSTOMER_RESOURCES_SCREEN = 'fastshiftPortalCustomerResourcesScreen',
	FASTSHIFT_PORTAL_PARTNER_RESOURCES_SCREEN = 'fastshiftPortalPartnerResourcesScreen',
	FASTSHIFT_PORTAL_GENERIC_ERROR_SCREEN = 'fastshiftPortalGenericErrorScreen',
	FASTSHIFT_PORTAL_404_SCREEN = 'fastshiftPortal404Screen',

	// M3
	FASTSHIFT_PORTAL_MIGRATION_TICKETS_SCREEN = 'fastshiftPortalMigrationTicketsScreen',
	FASTSHIFT_PORTAL_LEGAL_CONSENT_SCREEN = 'fastshiftPortalLegalConsentScreen',
	FASTSHIFT_PORTAL_CRITICAL_ERROR_SCREEN = 'fastshiftPortalCriticalErrorScreen',

	// Organizations
	FASTSHIFT_PORTAL_ORGANIZATIONS_SCREEN = 'fastshiftPortalOrganizationsScreen',
	FASTSHIFT_PORTAL_ORGANIZATION_DETAILS_SCREEN = 'fastshiftPortalOrganizationDetailsScreen',
}

export enum ActionKey {
	DISPLAYED = 'displayed',
	CLICKED = 'clicked',
	SUBMITTED = 'submitted',
	REDIRECTED = 'redirected',
}

export enum ActionSubjectKey {
	// General
	BUTTON = 'button',
	DROPDOWN = 'dropdown',
	FLAG = 'flag',
	DROPDOWN_ITEM = 'dropdownItem',
	MODAL = 'modal',
	SECTION = 'section',
	LINK = 'link',
	SEARCH = 'search',
	TABLE_COLUMN_SORT = 'tableColumnSort',
	PAGE = 'page',
}

export enum ActionSubjectIdKey {
	// EAP - Dashboard Screen
	REQUEST_FASTSHIFT_ASSISTANCE_CARD = 'requestFastshiftAssistanceCard',
	MIGRATION_PROGRESS_TABLE = 'migrationProgressTable',
	FASTSHIFT_RESOURCES_CARD_LINK_CLICK = 'fastshiftResourcesCardLinkClick',

	// Shared
	// EAP - Dashboard Screen & M2 - For You Screen
	ORG_SELECTOR_DROPDOWN = 'orgSelectorDropdown',
	MIGRATION_SUMMARY_SECTION = 'migrationSummarySection',
	// EAP - Dashboard Screen & M2 - Relationships Section: For You Screen & Migration Planning Screen
	REQUEST_FASTSHIFT_ASSISTANCE_MODAL = 'requestFastshiftAssistanceModal',
	REQUEST_FASTSHIFT_ASSISTANCE_MODAL_SUBMIT_BUTTON_CLICK = 'fastshiftAssistanceModalCommentSubmitButtonClick',
	REQUEST_FASTSHIFT_ASSISTANCE_COMMENT_CONFIRMATION_FLAG = 'postCommentOutcomeConfirmationFlag',

	// M2 - Dashboard Template
	PAGE_LAYOUT = 'pageLayout',

	// M2 - Selection Screen
	SELECTION_PAGE_DETAILS = 'selectionPageDetails',
	SEE_DETAILS_BUTTON = 'seeDetailsButton',
	DOMAIN_SELECTION_TABLE_SEARCH = 'domainSelectionTableSearch',
	SELECTION_TABLE_PAGE_NAVIGATION_BUTTON = 'selectionTablePageNavigationButton',
	SELECTION_TABLE_CHANGE_PAGE_SIZE_DROPDOWN_ITEM = 'selectionTableChangePageSizeDropdownItem',
	SELECTION_TABLE_COLUMN_SORT = 'selectionTableColumnSort',

	// M2 - For You Screen
	FOR_YOU_PAGE_DETAILS = 'forYouPageDetails',
	MIGRATION_TICKETS_TOP_SECTION_DETAILS = 'migrationTicketsTopSectionDetails',
	MIGRATION_TICKETS_TOP_SECTION_VIEW_ALL_LINK = 'migrationTicketsTopSectionViewAllLink',
	MIGRATION_TICKETS_TOP_SECTION_OPEN_SUPPORT_TICKET_LINK = 'migrationTicketsTopSectionOpenSupportTicketLink',

	// M2 - Migration Planning Screen
	MIGRATION_PLANNER_EMBED_SECTION = 'migrationPlannerEmbedSection',
	EMBED_VIEW_TYPE_TOGGLE_BUTTON = 'embedViewTypeToggleButton',
	SELECT_BOARD_DROPDOWN_ITEM = 'selectBoardDropdownItem',
	JIRA_EMBED_LINK = 'jiraEmbedLink',

	// M2 - Partner Resources Screen & Customer Resources Screen
	RESOURCE_FILTER = 'resourceFilter',
	RESOURCE_LINK = 'resourceLink',
	USEFUL_LINK = 'usefulLink',

	// M2 - Relationships Section: For You Screen & Migration Planning Screen
	REQUEST_ASSISTANCE_BUTTON = 'requestAssistanceButton',
	FASTSHIFT_RELATIONSHIPS_SECTION = 'fastshiftRelationshipsSection',

	// M2 -404 Display
	GO_BACK_TO_HOME_LINK = 'goBackToHomeLink',

	// M2 - Across All Screens
	SIDE_NAV_LINK = 'sideNavLink',
	CUSTOMER_SELECTION_BACK_LINK = 'customerSelectionBackLink',

	// M3 - Migration Tickets Screen
	MIGRATION_TICKETS_PAGE_DETAILS = 'migrationTicketsPageDetails',
	MIGRATION_TICKETS_TABLE_SEARCH = 'migrationTicketsTableSearch',
	MIGRATION_TICKETS_TABLE_PAGE_NAVIGATION_BUTTON = 'migrationTicketsTablePageNavigationButton',
	MIGRATION_TICKETS_TABLE_CHANGE_PAGE_SIZE_DROPDOWN_ITEM = 'migrationTicketsTableChangePageSizeDropdownItem',
	MIGRATION_TICKETS_TABLE_OPEN_SUPPORT_TICKET_LINK = 'migrationTicketsTableOpenSupportTicketLink',
	STATUS_FILTER_DROPDOWN = 'statusDropdown',
	MIGRATION_PHASE_DROPDOWN = 'migrationPhaseDropdown',
	CLEAR_FILTERS_BUTTON = 'clearFiltersButton',

	// Feedback Collector
	FEEDBACK_COLLECTOR_OPEN_BUTTON = 'feedbackCollectorOpenButton',
	FEEDBACK_COLLECTOR_SUBMIT_BUTTON = 'feedbackCollectorSubmitButton',

	// M3 - Legal Consent Page
	LEGAL_CONSENT_BUTTON = 'submitCustomerLegalConsentButton',
	REFRESH_PORTAL_BUTTON = 'criticalErrorRefreshPortalButton',

	// Migration Tickets Screen - Runbooks
	RELATED_TICKETS_ROW_EXPAND_TOGGLE = 'relatedTicketsRowExpandToggle',
	RELATED_TICKETS_ROW_OPEN_SUPPORT_TICKET_LINK = 'relatedTicketsRowOpenSupportTicketLink',
	VIEW_RUNBOOKS_BUTTON = 'viewRunbooksButton',
	RUNBOOKS_PANEL_DETAILS = 'runbooksPanelDetails',
	RUNBOOKS_PANEL_DISMISS_BUTTON = 'runbooksPanelDismissButton',

	// Migration Tickets Screen - Runbook Card
	RUNBOOK_CARD_EXPAND_TOGGLE = 'runbookCardExpandToggle',
	RUNBOOK_DETAILS = 'runbookDetails',
	RUNBOOK_OPEN_IN_MARATHON_LINK = 'runbookOpenInMarathonLink',

	// Migration Tickets Screen - Runbook Step Actions
	RUNBOOK_STEP_ACTIONS_MENU = 'runbookStepActionsMenu',
	RUNBOOK_STEP_STATUS_TOGGLE = 'runbookStepStatusToggle',
	RUNBOOK_STEP_RISK_TOGGLE = 'runbookStepRiskToggle',
	RUNBOOK_STEP_DISABLE_TOGGLE = 'runbookStepDisableToggle',
	RUNBOOK_STEP_ACTION_ERROR_FLAG = 'runbookStepActionErrorFlag',

	// Migration Tickets Screen - Runbook Step Modals
	RUNBOOK_STEP_STATUS_CONFIRM_MODAL = 'runbookStepStatusConfirmModal',
	RUNBOOK_STEP_STATUS_CONFIRM_BUTTON = 'runbookStepStatusConfirmButton',
	RUNBOOK_STEP_STATUS_CONFIRM_CANCEL_BUTTON = 'runbookStepStatusConfirmCancelButton',
	RUNBOOK_STEP_DISABLE_CONFIRM_MODAL = 'runbookStepDisableConfirmModal',
	RUNBOOK_STEP_DISABLE_CONFIRM_BUTTON = 'runbookStepDisableConfirmButton',
	RUNBOOK_STEP_DISABLE_CANCEL_BUTTON = 'runbookStepDisableCancelButton',

	// SideNav - Flyout
	SIDE_NAV_FLYOUT_BUTTON = 'sideNavFlyoutButton',
	FLYOUT_ITEM_LINK = 'flyoutItemLink',
	FLYOUT_VIEW_ALL_LINK = 'flyoutViewAllLink',
	ORGANIZATIONS_FLYOUT = 'organizationsFlyout',

	// Organizations list
	ORGANIZATIONS_PAGE_DETAILS = 'organizationsPageDetails',
	ORGANIZATION_CARD = 'organizationCard',

	// Organizations - Detail
	ORGANIZATION_SUMMARY_SECTION = 'organizationSummarySection',
	ORGANIZATION_DC_INSTANCES_TABLE = 'organizationDcInstancesTable',
	DC_INSTANCES_TABLE_PAGE_NAVIGATION_BUTTON = 'dcInstancesTablePageNavigationButton',
	DC_INSTANCES_TABLE_CHANGE_PAGE_SIZE_DROPDOWN_ITEM = 'dcInstancesTableChangePageSizeDropdownItem',
}

export enum SubjectAttributeKey {
	// EAP - Dashboard Screen
	SEARCH_SUPPORT = 'Search Support',
	ATLASSIAN_COMMUNITY = 'Atlassian Community',
	ATLASSIAN_DOCUMENTATION = 'Atlassian Documentation',

	// Shared: EAP - Dashboard Screen & M2 - For You Screen
	VIEW_ASSESSMENTS = 'View Assessments',
	VIEW_MIGRATIONS = 'View Migrations',
}
